export default {
      id: "invesment-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#invesment",
      toString: function () {
        return this.url;
      }
    }